import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatevCloudIcon, PathwayIconWrapperButton } from "../_UI/StyledComponents/PathwayIcons";
import { PathwayButton } from "../_UI/Components/PathwayButtons";
import { DatevConnection } from "../organization/client/components/DatevConnection";
import { getDatevConnections } from "../organization/client/services/clients.actions";
import { sortNumValuesByField } from "../_services/sorting-helper";
import stringUtils from "../_services/string-utils";
import listUtils from "../_services/list-utils";

const SIZE_MAP = {
    small: "35px",
    medium: "45px",
    large: "50px",
};

const DatevConnectionButton = ({
    clients,
    variant = "button",
    iconHeight = "small",
    dataCy = "datev-connection-modal-button",
    ariaLabel = "DATEV-Verbindung öffnen",
    label = "DATEV-Verbindung",
    isOpen: externalIsOpen,
    onClose: externalOnClose,
}) => {
    const dispatch = useDispatch();
    const { existingDatevConnections, getDatevConnectionsLoading } = useSelector((state) => state.client);
    const [internalOpen, setInternalOpen] = useState(false);

    const resolvedHeight = SIZE_MAP[iconHeight] ?? iconHeight;
    const showModal = internalOpen || !!externalIsOpen;

    const availableDatevConnections = useMemo(() => {
        const safeClients = Array.isArray(clients) ? clients : [];
        return [
            ...new Map(
                sortNumValuesByField(
                    sortNumValuesByField(
                        safeClients.filter(
                            (c) =>
                                !stringUtils.isBlank(c.consultantNumber) &&
                                !stringUtils.isBlank(c.clientNumber)
                        ),
                        "clientNumber"
                    ),
                    "consultantNumber"
                ).map((c) => [
                    c.consultantNumber + "/" + c.clientNumber,
                    { consultantNumber: c.consultantNumber, clientNumber: c.clientNumber },
                ])
            ).values(),
        ];
    }, [clients]);

    const openModal = useCallback(() => {
        if (listUtils.isEmpty(existingDatevConnections) && !getDatevConnectionsLoading) {
            dispatch(getDatevConnections());
        }
        setInternalOpen(true);
    }, [dispatch, existingDatevConnections, getDatevConnectionsLoading]);

    const closeModal = useCallback(() => {
        setInternalOpen(false);
        if (externalOnClose) externalOnClose();
    }, [externalOnClose]);

    return (
        <>
            {variant === "icon" ? (
                <PathwayIconWrapperButton color="link" onClick={openModal} data-cy={dataCy} aria-label={ariaLabel}>
                    <DatevCloudIcon style={{ height: resolvedHeight }} />
                </PathwayIconWrapperButton>
            ) : (
                <PathwayButton color="secondary" onClick={openModal} dataCy={dataCy}>
                    <DatevCloudIcon style={{ height: "16px", width: "16px" }} />
                    {label}
                </PathwayButton>
            )}

            <DatevConnection
                showModal={showModal}
                closeModal={closeModal}
                availableConnections={availableDatevConnections}
            />
        </>
    );
};

export default DatevConnectionButton;
